import { Link } from '@design-system/link';
import classNames from 'classnames';
import React, { FC } from 'react';

import { getLinkSize } from '../../utils/getLinkSize';
import { shouldBeRendered } from '../../utils/shouldBeRendered';
import { SubNavigationProps } from './models';

export const SubNavigation: FC<SubNavigationProps> = ({
  className,
  subItems,
  linkNavElement: LinkElement = Link,
  subMenuLabel,
  activeUrlPath,
  handleFocus,
  handleBlur,
  isMobileView,
  href,
  ariaLabel,
  handleMobileNavigationItemClick,
  onClickSubnavItem,
}) => {
  const handleClick = (subLabel) => {
    if (onClickSubnavItem) onClickSubnavItem(subLabel);
    if (isMobileView) handleMobileNavigationItemClick();
  };

  return (
    <div
      className={classNames('cds-global-header__navigation-drop', className)}
    >
      <ul className="cds-global-header__sub-list">
        {shouldBeRendered(
          subMenuLabel,
          [isMobileView, Boolean(href)],
          'and'
        ) && (
          <li className="cds-navigation__sub-item">
            <LinkElement
              className={classNames('cds-navigation__sub-link', {
                active: activeUrlPath === href,
              })}
              aria-current={activeUrlPath === href}
              aria-label={ariaLabel}
              onClick={handleMobileNavigationItemClick}
              href={href}
              variant="nav"
              size="large"
              onFocus={handleFocus}
              onBlur={handleBlur}
            >
              {subMenuLabel}
            </LinkElement>
          </li>
        )}
        {subItems.map(
          ({
            label: subLabel,
            href: subHref,
            ariaLabel: subAriaLabel,
            // exclude subMenuLabel and subItems props so that they're not rendered on link
            subMenuLabel: _subMenuLabel,
            subItems: _subItems,
            ...subItem
          }) => (
            <li key={subLabel}>
              <LinkElement
                className={classNames('cds-global-header__sub-link', {
                  active: activeUrlPath === subHref,
                })}
                aria-current={activeUrlPath === subHref}
                {...subItem}
                aria-label={subAriaLabel}
                onClick={() => handleClick(subLabel)}
                href={subHref}
                variant="nav"
                size={getLinkSize(isMobileView)}
                onFocus={handleFocus}
                onBlur={handleBlur}
              >
                {subLabel}
              </LinkElement>
            </li>
          )
        )}
      </ul>
    </div>
  );
};
